<script>
export default {
  name: "neighborhood-updater",
  data() {
    return {
      popupActivo: false,
      state_id: null,
      statesList: [],
    }
  },
  mounted() {
    this.getCollections();
  },
  computed: {
    statesListOptions() {
      let options = [];
      this.statesList.forEach(opt => {
        options.push({value: parseInt(opt.id), text: opt.real_name}); //conversion a sintaxis de vx-select
      });

      return options;
    }
  },
  methods: {
    async getCollections() {
      try {
        let collectionsObjects = ['statesList'];
        let params = "with[]=" + collectionsObjects.join("&with[]=");
        let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
        this.statesList = res.data.statesList;
      } catch (e) {
        console.log(e);
        this.warn(e);
        this.failed = true;
      }
    },
    async requestPostLayout() {
      let ok = document.getElementById("layout").files.length > 0;
      if (!ok && this.state_id == null) {
        this.missingFieldsNotif();
        return;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Cargar layout de neighborhoods.',
        text: `¿Estás seguro que deseas cargar el layout? La BD existente será actualizada.`,
        acceptText: "Cargar layout",
        cancelText: 'Cancelar',
        accept: this.doPostLayout
      });
    },
    async doPostLayout() {
      try {
        let doc = document.getElementById("layout");
        const data = new FormData();
        if (doc.files.length > 0) {
          this.showLoading(true);
          data.append("neighborhoods_layout", doc.files[0]);
          const res = await axios.post(`/api/neighborhoods/${this.state_id}/updateByCSV`, data);
          this.showLoading(false);
          this.saveSuccessNotif();
        } else {
          this.warningNotif("Importante", "No se ha seleccionado ningún layout para cargar.");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.showLoading(false);
      }
    },
  }
}
</script>

<template>
  <div class="container mt-5">
    <vx-card title="Actualizar colonias">
      <vs-button @click.stop="popupActivo = true">
        Actualizar neighborhoods
      </vs-button>
    </vx-card>
    <vs-popup class="mid-popup header-primary" title="Actualizar neighborhoods" :active.sync="popupActivo">
      <vx-card>
        <p>Esta herramienta funciona en conjunto con la información descargada desde el <a
            href="https://www.correosdemexico.gob.mx/SSLServicios/ConsultaCP/CodigoPostal_Exportar.aspx" target="_blank"
            rel="noopener noreferrer">Servicio Postal Mexicano</a>;
          Es necesario formatear el documento separado por comas (.csv), se utilizan las columnas "<strong>d_codigo,
            d_asenta, c_mnpio y id_asenta_cpcons</strong>".
          La actualización se realiza por estado.
        </p>

        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <label class="vs-input--label">Estado *</label>
            <v-select label="text" class="vs-custom w-full" v-model.lazy="state_id" :options="statesListOptions"
                      :reduce="text => text.value" :clearable="false" :searchable="true"
                      :disabled="!statesList || !statesList.length" placeholder="Seleccione una opción">
              <div slot="no-options">No hay coincidencias</div>
            </v-select>
          </div>
          <div class="vx-col w-full">
            <input class="m-4" ref="fileInput" id="layout" text="Seleccione el layout" accept="*" accept-charset="utf-8"
                   fileName="file"
                   type="file"/> <br>
            <vs-button @click="requestPostLayout()" class="m-4" color="dark">Cargar</vs-button>
          </div>
        </div>
      </vx-card>
    </vs-popup>
  </div>
</template>

<style scoped>

</style>